import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EditPage, EditTreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const AddBtnSameLevel = (props: Props) => {
  const tree = useContext(EditTreeContext)

  const handleClose = () => {
    const parentTree = tree.flatTreeData.find((item: any) => item.ID === tree.selectedNodes[0].PARENT_ID)
    tree.getTreeData(parentTree)
  }

  const formData = useMemo(() => {
    // 新增同级时，要把当前节点的父节点 ID 当作 parentFormId
    return { parentFormId: tree.selectedNodes[0]?.PARENT_ID }
  }, [tree.selectedNodes[0]?.PARENT_ID])

  const formCode = tree.treeConfig.Nav_Form?.CODE
  const { LABEL, ICON, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='PlusCircleOutlined' />}
      onClose={handleClose}
    >
      <EditPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default AddBtnSameLevel